import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';

export const IMAGE_COMPARISON_STYLE_SCHEMA = {
  ratio: { default: '16/9' },
  accent: { default: '' },
  labelBackground: { default: '#000000bb' },
  handleSize: { default: '2.75rem' },
  border: { default: () => ({ ...BORDERLESS_BORDER }) },
  shadow: { default: 'none' },
  textStyles: { default: {} },
};
